import React, { useState } from 'react';
import { Search, MapPin } from 'lucide-react';

const CityCoverage = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const cityData = {
    tier1: {
      title: "Tier 1 Cities",
      cities: [
        "Delhi", "Mumbai", "Kolkata", "Chennai", "Pune", "Bangalore", "Hyderabad", "Kochi"
      ]
    },
    tier2: {
      title: "Tier 2 Cities",
      cities: [
        "Agra", "Ahmedabad", "Ambala", "Amritsar", "Aurangabad", "Belgaun", "Bhatinda",
        "Bhavnagar", "Bhopal", "Bhubaneshwar", "Bikaner", "Chandigarh", "Cochin", "Coimbatore",
        "Cuttuck", "Dehradun", "Guwahati", "Indore", "Jabalpur", "Jaipur", "Jalandhar", "Jammu",
        "Jamnagar", "Jamshedpur", "Jodhpur", "Lukhnow", "Ludhiana", "Nagpur", "Nasik", "Patna",
        "Raipur", "Vadodara", "Varanasi", "Vishakapatnam", "Udaipur", "Ranchi", "Goa"
      ]
    },
    tier3: {
      title: "Tier 3 Cities",
      cities: [
        "Surat", "Mangalore", "Bareily", "Bhiwandi", "Gorakhpur", "Gwalior", "Hubli", "Dharwad",
        "Kolhapur", "Kota", "Kozhikode", "Kurukshetra", "Madurai", "Meerut", "Mysore", "Pathankot",
        "Patiala", "Pondicherry", "Rajamundry", "Rajkot", "Shilong", "Siliguri", "Srinagar",
        "Thrissur", "Trichy", "Tirupati", "Vijaywada"
      ]
    }
  };

  const filterCities = (cities) => {
    if (!searchTerm) return cities;
    return cities.filter(city => 
      city.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const getTotalCities = () => {
    return cityData.tier1.cities.length + cityData.tier2.cities.length + cityData.tier3.cities.length;
  };

  const hasResults = () => {
    return filterCities(cityData.tier1.cities).length > 0 ||
           filterCities(cityData.tier2.cities).length > 0 ||
           filterCities(cityData.tier3.cities).length > 0;
  };

  return (
    <div className="min-h-screen bg-yellow-50">
      {/* Header */}
      <div className="bg-yellow-400 shadow">
        <div className="max-w-6xl mx-auto px-4 py-8 text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-black mb-2">
            Our City Coverage
          </h1>
          <p className="text-black text-lg">
            Serving {getTotalCities()} Cities Across India
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-8">
        {/* Search Bar */}
        {/* <div className="bg-white rounded-lg shadow p-4 mb-8">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input
              type="text"
              placeholder="Search for a city..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-yellow-400"
            />
          </div>
        </div> */}

        {/* City Sections */}
        <div className="space-y-8">
          {Object.keys(cityData).map(tierKey => {
            const tier = cityData[tierKey];
            const filteredCities = filterCities(tier.cities);

            if (filteredCities.length === 0) return null;

            return (
              <div key={tierKey} className="bg-white rounded-lg shadow p-6">
                <h2 className="text-2xl font-bold text-black mb-4 pb-2 border-b-2 border-yellow-400">
                  {tier.title} ({filteredCities.length})
                </h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
                  {filteredCities.map((city, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-2 p-2 rounded hover:bg-yellow-50 transition"
                    >
                      <MapPin className="w-4 h-4 text-yellow-600 flex-shrink-0" />
                      <span className="text-black font-medium text-sm">{city}</span>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        {/* No Results */}
        {searchTerm && !hasResults() && (
          <div className="text-center py-12">
            <p className="text-xl text-gray-600">
              No cities found matching "{searchTerm}"
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CityCoverage;